package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.AtariSimpleIcons: ImageVector
    get() {
        if (_atariSimpleIcons != null) {
            return _atariSimpleIcons!!
        }
        _atariSimpleIcons = Builder(name = "AtariSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(0.0f, 21.65f)
                reflectiveCurveToRelative(3.15f, -0.36f, 5.61f, -2.38f)
                curveToRelative(2.34f, -1.93f, 3.19f, -3.59f, 3.77f, -5.48f)
                curveToRelative(0.58f, -1.89f, 0.67f, -6.42f, 0.67f, -7.76f)
                lineTo(10.05f, 2.35f)
                lineTo(8.60f, 2.35f)
                verticalLineToRelative(1.37f)
                curveToRelative(-0.02f, 2.04f, -0.2f, 5.92f, -1.14f, 8.44f)
                curveTo(5.20f, 18.24f, 0.0f, 18.78f, 0.0f, 18.78f)
                close()
                moveTo(24.0f, 21.65f)
                reflectiveCurveToRelative(-3.15f, -0.36f, -5.61f, -2.38f)
                curveToRelative(-2.34f, -1.93f, -3.19f, -3.59f, -3.77f, -5.48f)
                curveToRelative(-0.58f, -1.89f, -0.67f, -6.42f, -0.67f, -7.76f)
                lineTo(13.95f, 2.35f)
                lineTo(15.4f, 2.35f)
                lineToRelative(0.00f, 1.37f)
                curveToRelative(0.02f, 2.04f, 0.20f, 5.92f, 1.14f, 8.44f)
                curveToRelative(2.26f, 6.09f, 7.46f, 6.62f, 7.46f, 6.62f)
                close()
                moveTo(10.66f, 2.35f)
                horizontalLineToRelative(2.69f)
                verticalLineToRelative(19.31f)
                lineTo(10.66f, 21.65f)
                close()
            }
        }
        .build()
        return _atariSimpleIcons!!
    }

private var _atariSimpleIcons: ImageVector? = null
